export default function() {
    let defaultLanguage;
    try {
        defaultLanguage = Em.I18n.translations.GesagtGetan_Basic.Language.Code;
    } catch (error) {
    } finally {
        return typeof defaultLanguage === "string" ? defaultLanguage : false;
    }
}
